import ExtendableError from "es6-error";

export default class ForbiddenHttpError extends ExtendableError {
    constructor(message = "Forbidden.") {
        super(message);
    }
}
